export default __webpack_public_path__ + "static/media/AAPG-Pivoting-1.687f7168.png";